import { render, staticRenderFns } from "./MentorshipGroupChat.vue?vue&type=template&id=32d9b2a1&"
import script from "./MentorshipGroupChat.vue?vue&type=script&lang=js&"
export * from "./MentorshipGroupChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports